// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".w-option-list{list-style:none;margin-bottom:0;outline:none;padding:0}.w-option-list>li{outline:none}.w-option-list--scrollable{overflow-x:hidden;overflow-y:auto}.w-option-list--scrollable.w-option-list--orientation-horizontal{overflow-x:auto;overflow-y:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
